const translations = {
  "en": {
    "Complete Tasks for Free Credits": "Complete Tasks for Credits",
    "Don't Miss the Next Alpha.": "Don't Miss the Next Alpha.",
    "Get Unlimited Access": "Get Unlimited Access",
    "You're down to %{credits} Credits. Upgrade to Pro for unlimited signals and never miss a trade.": "You're down to %{credits} Credits. Upgrade to Pro for unlimited signals and never miss a trade."
  },
  "zh-tw": {
    "Complete Tasks for Free Credits": "完成任務獲取點數",
    "Don't Miss the Next Alpha.": "不要錯過下一個獲利機會。",
    "Get Unlimited Access": "取得無限存取權限",
    "You're down to %{credits} Credits. Upgrade to Pro for unlimited signals and never miss a trade.": "你只剩 %{credits} 點數。升級至 Pro，享無限訊號，不錯過任何一筆交易。"
  }
};

export default translations;
